import api from './api';

export interface Customer {
  id: number;
  code: string;
  name: string;
  phone?: string;
  email?: string;
  address?: string;
  tax_code?: string;
  contact_person?: string;
  notes?: string;
  status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
  total_orders?: number;
  total_amount?: number;
}

export interface CustomerDetail {
  customer: Customer;
  orders: any[];
}

export const customerService = {
  // Lấy danh sách khách hàng
  getCustomers: async (params?: any) => {
    const response = await api.get('/api/customers', { params });
    return response.data;
  },

  // Lấy chi tiết khách hàng
  getCustomerDetail: async (id: number) => {
    const response = await api.get(`/api/customers/${id}`);
    return response.data.data;
  },

  // Tạo khách hàng mới
  createCustomer: async (data: any) => {
    const response = await api.post('/api/customers', data);
    return response.data;
  },

  // Cập nhật khách hàng
  updateCustomer: async (id: number, data: any) => {
    const response = await api.put(`/api/customers/${id}`, data);
    return response.data;
  },

  // Xóa khách hàng
  deleteCustomer: async (id: number) => {
    const response = await api.delete(`/api/customers/${id}`);
    return response.data;
  },

  // Lấy danh sách khách hàng cho select
  getCustomersForSelect: async (params?: any) => {
    const response = await api.get('/api/customers/select/list', { params });
    return response.data.data;
  }
}; 